import { gql } from "@apollo/client";

export const CONFIRM_TOKEN = gql`
  mutation ConfirmToken($pubKey: String!) {
    cliConfirmationToken(pubKey: $pubKey)
  }
`;
